import { createActionCreator } from '@pressreader/appstore';
import { AnyFeedCursor } from '@pressreader/feed-types';

import { MODULE_NAME } from '../../constants';
import { ArticleActionPayload } from '../../types/article.action.payload';

const prefix = `${MODULE_NAME}/navigation/`;

export const navigateToListenAction = createActionCreator<ArticleActionPayload>(`${prefix}navigate-to-listen`);

export const navigateToPageAction = createActionCreator<{
    articleId: string;
    viewContextKey?: string;
    /**
     * Carry the article into the PageView as its smart-zoom target (default). The PageView resolves it to the
     * article's region and zooms the page onto it — what "view on page" means from a page thumb, the article
     * context menu or a search hit. A plain view switch back to the page passes `false` and lands on the
     * article's page fitted to the selected display mode.
     */
    zoomToArticle?: boolean;
}>(`${prefix}navigate-to-page`);

export const navigateToTextAction = createActionCreator<{
    articleId: string;
    viewContextKey?: string;
}>(`${prefix}navigate-to-text`);

export const navigateToArticleAction = createActionCreator<{
    cursor?: AnyFeedCursor | null;
    articleId: string;

    /** If navigating to already translated article, keep the translation. */
    keepTranslation?: boolean;
    languageCode?: string | null;

    replace?: boolean;
}>(`${prefix}navigate-to-article`);

export const navigateToArticleByIssueKey = createActionCreator<{
    articleId: string;
    issueKey: string;
    /**
     * Whether to open the article in a popup or view mode.
     */
    displayMode?: 'popup' | 'view';
}>(`${prefix}navigate-to-article-by-issue-key`);
